export const faqs = [
    {
        category: "General",
        questions: [
            {
                q: "What is CardBox?",
                a: "CardBox is a digital identity platform that replaces paper visiting cards. It allows professionals to create a shareable 'Digital Card' and helps customers find trusted local service providers like plumbers, electricians, and designers."
            },
            {
                q: "Is CardBox free to use?",
                a: "Yes! Creating a basic Digital Card and searching for providers is completely free. We also offer a 'Verified Pro' premium plan for professionals who want higher visibility and advanced features."
            },
        ]
    },
    {
        category: "For Service Providers",
        questions: [
            {
                q: "How do I create my Digital Card?",
                a: "Simply click on 'Get Started', sign up with your phone number, and fill in your business details. Your card will be live instantly!"
            },
            {
                q: "How can I share my card?",
                a: "You can share your card via WhatsApp, copy your unique profile link, or show your QR code directly from your dashboard."
            },
            {
                q: "What is the 'Verified Pro' badge?",
                a: "The Verified badge helps you build trust. It requires document verification (like Aadhaar/PAN) and a small subscription fee. Verified profiles appear at the top of search results."
            }
        ]
    },
    {
        category: "Billing & Support",
        questions: [
            {
                q: "Can I cancel my subscription?",
                a: "Yes, you can cancel your Verified Pro subscription at any time from your dashboard settings. You will retain access until the billing cycle ends."
            },
            {
                q: "How do I contact support?",
                a: "You can reach us via the 'Contact Us' page or email us directly at support@cardbox.in."
            }
        ]
    }
];
